import { useEffect, useState } from "react";
import { straconClient } from "../../../util/Api";
import { useCookies } from "react-cookie";

export const useProvideAuth = () => {
  const [authUser, setAuthUser] = useState(null);
  const [error, setError] = useState("");
  const [isLoadingUser, setLoadingUser] = useState(true);
  const [isLoading, setLoading] = useState(false);

  const [cookies, setCookie] = useCookies(["trackingsessionid"]);

  const fetchStart = () => {
    setLoading(true);
    setError("");
  };

  const fetchSuccess = () => {
    setLoading(false);
    setError("");
  };

  const fetchError = (error) => {
    setLoading(false);
    setError(error);
  };

  const userLogin = (values, callbackFun) => {
    console.log('[Auth:userLogin] Cookie trackingsessionid:', cookies.trackingsessionid, '| values:', values);
    console.log('[Auth:userLogin] TOKEN configurado:', !!process.env.REACT_APP_TOKEN_API_STRACON);
    straconClient.defaults.headers.common["Authorization"] =
      process.env.REACT_APP_TOKEN_API_STRACON;

    if (cookies.trackingsessionid) {
      console.log('[Auth:userLogin] Llamando get_usuario con sessionid:', cookies.trackingsessionid);
      fetchStart();
      straconClient
        .get("get_usuario/", {
          params: {
            trackingsessionid: cookies.trackingsessionid,
          },
        })
        .then(({ data }) => {
          console.log('[Auth:userLogin] Respuesta get_usuario:', data);
          if (data.is_active) {
            fetchSuccess();
            getAuthUser();
            if (callbackFun) callbackFun();
          } else {
            fetchError(data.error);
          }
        })
        .catch(function (error) {
          console.error('[Auth:userLogin] Error:', error.message, error.response?.status, error.response?.data);
          fetchError(error.message);
        });
    } else {
      console.warn('[Auth:userLogin] No hay cookie trackingsessionid - necesitas loguearte primero en el admin Django');
    }
  };

  const userSignup = (user, callbackFun) => {
    fetchStart();
    straconClient
      .post("auth/register", user)
      .then(({ data }) => {
        if (data.result) {
          fetchSuccess();
          //localStorage.setItem("token", data.token.access_token);
          straconClient.defaults.headers.common["Authorization"] =
            process.env.REACT_APP_TOKEN_API_STRACON;
          getAuthUser();
          if (callbackFun) callbackFun();
        } else {
          fetchError(data.error);
        }
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  const sendPasswordResetEmail = (email, callbackFun) => {
    fetchStart();

    setTimeout(() => {
      fetchSuccess();
      if (callbackFun) callbackFun();
    }, 300);
  };

  const confirmPasswordReset = (code, password, callbackFun) => {
    fetchStart();

    setTimeout(() => {
      fetchSuccess();
      if (callbackFun) callbackFun();
    }, 300);
  };

  const renderSocialMediaLogin = () => null;

  const userSignOut = (callbackFun) => {
    straconClient.defaults.headers.common["Authorization"] = "";
    //localStorage.removeItem("token");
    cookies.trackingsessionid = "";
    setAuthUser(false);
    callbackFun();
  };

  /*   const userSignOut = (callbackFun) => {
      fetchStart();
      straconClient
        .post('auth/logout')
        .then(({ data }) => {
          if (data.result) {
            fetchSuccess();
            straconClient.defaults.headers.common['Grpc-Metadata-Authorization'] = '';
            localStorage.removeItem('token');
            setAuthUser(false);
            if (callbackFun) callbackFun();
          } else {
            fetchError(data.error);
          }
        })
        .catch(function (error) {
          fetchError(error.message);
        });
    }; */

  const getAuthUser = () => {
    if (cookies.trackingsessionid) {
      fetchStart();
      straconClient
        .get("get_usuario/", {
          params: {
            trackingsessionid: cookies.trackingsessionid,
          },
        })
        .then(({ data }) => {
          if (data.is_active) {
            //if (data.user) {
            fetchSuccess();
            setAuthUser(data);
          } else {
            fetchError(data.error);
          }
        })
        .catch(function (error) {
          //straconClient.defaults.headers.common['Grpc-Metadata-Authorization'] = '';
          fetchError(error.message);
        });
    }
  };

  // Subscribe to user on mount
  // Because this sets state in the callback it will cause any ...
  // ... component that utilizes this hook to re-render with the ...
  // ... latest auth object.

  useEffect(() => {
    console.log('[Auth:init] Cookie trackingsessionid:', cookies.trackingsessionid);
    console.log('[Auth:init] REACT_APP_TOKEN_API_STRACON configurado:', !!process.env.REACT_APP_TOKEN_API_STRACON);
    console.log('[Auth:init] REACT_APP_ADMIN_URL:', process.env.REACT_APP_ADMIN_URL);
    straconClient.defaults.headers.common["Authorization"] =
      process.env.REACT_APP_TOKEN_API_STRACON;
    straconClient
      .get("get_usuario/", {
        params: {
          trackingsessionid: cookies.trackingsessionid,
        },
      })
      .then(({ data }) => {
        console.log('[Auth:init] Respuesta get_usuario:', data);
        if (cookies.trackingsessionid) {
          if (data.is_active) {
            setAuthUser(data);
          }
        }
        setLoadingUser(false);
      })
      .catch(function (error) {
        console.error('[Auth:init] Error get_usuario:', error.message, error.response?.status, error.response?.data);
        straconClient.defaults.headers.common["Authorization"] = "";
        setLoadingUser(false);
      });
  }, []);

  // Return the user object and auth methods
  return {
    isLoadingUser,
    isLoading,
    authUser,
    error,
    setError,
    setAuthUser,
    getAuthUser,
    userLogin,
    userSignup,
    userSignOut,
    renderSocialMediaLogin,
    sendPasswordResetEmail,
    confirmPasswordReset,
  };
};
